module.exports = __webpack_public_path__ + "r-v3/img/ml_09_00.48c03dd8.jpg";